import React from 'react'
import ReactSidebar from 'react-sidebar'

import { ZIndexContext } from '@/common/z-index'
import { hideScrollbar } from '@/css-helpers/helpers'
import { white } from '@/refactor/colors'
import styled, { muiUtils, padPx, size, useIsMobile } from '@/styles'
import { DefaultProps, HEADER_HEIGHT, MOBILE_HEADER_HEIGHT } from '@/travelsuit'

interface IProps extends DefaultProps {
	open?: boolean
	onToggle?(open: boolean): void
}

const SidebarContent = styled.div`
	${size('100vw', `calc(100vh - ${HEADER_HEIGHT}px)`)}
	background: ${white};
	overflow-y: auto;

	${muiUtils.mobile} {
		${size('100vw', `calc(100vh - ${MOBILE_HEADER_HEIGHT}px)`)}
		${hideScrollbar()}
	}
`

const Z_INDEX = 100000

export const Sidebar: React.FC<IProps> = ({ open, onToggle, children }) => {
	const shouldUseMobileStyles = useIsMobile()

	const getContent = () => (
		<SidebarContent>
			<ZIndexContext.Provider value={Z_INDEX}>{children}</ZIndexContext.Provider>
		</SidebarContent>
	)

	const sidebarTransform = '.25s cubic-bezier(0.4, 0.0, 0.2, 1)'

	return (
		<ReactSidebar
			open={open}
			onSetOpen={onToggle}
			pullRight
			touchHandleWidth={0}
			dragToggleDistance={100}
			sidebar={getContent()}
			touch={!shouldUseMobileStyles}
			styles={{
				root: {
					position: 'fixed',
					top: padPx(shouldUseMobileStyles ? MOBILE_HEADER_HEIGHT : HEADER_HEIGHT),
					zIndex: String(Z_INDEX),
					pointerEvents: open ? 'all' : 'none',
				},
				overlay: { width: open ? undefined : '20px', background: 'transparent' },
				sidebar: {
					transition: `transform ${sidebarTransform}`,
					WebkitTransition: `-webkit-transform ${sidebarTransform}`,
				} as Partial<CSSStyleDeclaration>,
			}}
		>
			{''}
		</ReactSidebar>
	)
}
